module.exports = __webpack_public_path__ + "img/back-arrow-primary.170ff64d.svg";